module.exports = __webpack_public_path__ + "src/img/bgWord.9e54f4da.png";